import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { environment } from 'src/environments/environment';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key : "Content-Type",
    value: 'application/json',
    required: false
  },  
  {
    key : "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key : "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
];
const QueryData :any =[
  {
    param : "lat",
    value: '{{lat}}',
    required: true
  },
  {
    param : "lon",
    value: '{{lon}}',
    required: true
  },
  {
    param : "land_area",
    value: '{{land_area}}',
    required: false
  },
  {
    param : "filter",
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
  "unit_area": "340.77",
  "total_rooms": "1 or more",
  "bathrooms": "1 or more",
  "kitchen": "1 or more",
  "is_furnished": "1 or 0",
  "split_unit": "0",
  "central_ac": "1, 2 or 3",
  "parking_available": "1 or 0",
  "total_floors": "1 or more",
  "units_per_floor": "1 or more",
  "total_units_in_contract": "1 or 0",
  "apartment_unit": "1 or 0",
  "duplex_unit": "1 or 0",
  "floor_unit": "1 or 0",
  "rooftop_apartment_unit": "1 or 0",
  "rooftop_floor_unit": "1 or 0",
  "secondary_apartment_unit": "1 or 0",
  "studio_unit": "1 or 0",
  "villa_unit": "1 or 0",
  "property_building": "1 or 0",
  "property_villa": "1 or 0",
  "construction_old": "1 or 0",
  "construction_medium": "1 or 0",
  "construction_new": "1 or 0",
  "property_other": "1 or 0"
}`,
    required: false
  }
]

@Component({
  selector: 'app-avm-rental',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, ApiTitleComponent, ApiUIResponseComponent],
  templateUrl: './avm-rental.component.html'
})
export class AvmRentalComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;
  api_ui:boolean=false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService, 
      private userService: UserService, 
      private router: Router){}

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
        this.userService.getAllUserResource(userInfo.user_id)
          .subscribe({
            next: (res: any) => {
              const matched = res.data.find((r: any) => r.resource_name === Resource.AvmRental);
                if (!matched?.methods?.includes(HTTPMethod.GET)) {
                 this.router.navigate(['/'])
                }
            },
            error: (err) => {
            }
          })
   }

  ngAfterViewInit(){
   
  }

  api_demo= `${environment.apiBaseUrl}${apiEndPoints.avmRental}`;

  api_response = `{
  "status": 0,
  "message": "string",
  "data": {
    "property_uid": "string",
    "apartment_rental_midpoint": 0,
    "apartment_rental_lower_range": 0,
    "apartment_rental_higher_range": 0,
    "average_growth_rate": {
      "2022": "-3.2",
      "2023": "-19.3",
      "2024": "50"
    },
    "street_data": [
      {
        "road_name": "string",
        "category": "string",
        "distance": 0
      }
    ]
  }
}`;

}
